module.exports = __webpack_public_path__ + "static/img/lb.528d7e0a.svg";